<script lang="ts">
import localStore from 'store';
import { defineComponent } from 'vue';

import constants from '@/constants';
import { error as logError } from '@/logger';
import { useAppInfoStore } from '@/stores/appInfo';

export default defineComponent({
  name: 'BaseRedirect',
  // when navigating to `/` we redirect to DashboardPage on single or Secondary clusters
  // and ClustersPage on Multi-Cluster Primary clusters
  async beforeRouteEnter(to, from) {
    // if "isMulticluster" localStorage value is undefined
    // we need to wait on systemInfo to determine if this is a primary
    if (!localStore.get(constants.localStorage.IS_MULTICLUSTER)) {
      const appInfoStore = useAppInfoStore();
      // if systemInfo has not been returned yet we need to fetch it
      if (appInfoStore.systemInfo === null) await appInfoStore.fetchSystemInfo().catch(logError);
      if (appInfoStore.isMCPrimary) return { name: 'MCClusters' };
    }
    // otherwise we can redirect immediately based on the localStorage value
    if (localStore.get(constants.localStorage.IS_MULTICLUSTER) === true) {
      return { name: 'MCClusters' };
    }
    return { name: 'Dashboard' };
  },
});
</script>
